module.exports = __webpack_public_path__ + "static/media/waterfall-pond.62dcd3d8.png";